"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AccountStates;

(function (AccountStates) {
  AccountStates["Created"] = "Created";
  AccountStates["Deployed"] = "Deployed";
})(AccountStates = exports.AccountStates || (exports.AccountStates = {}));

var AccountTypes;

(function (AccountTypes) {
  AccountTypes["Developer"] = "Developer";
  AccountTypes["Admin"] = "Admin";
})(AccountTypes = exports.AccountTypes || (exports.AccountTypes = {}));

var AccountDeviceStates;

(function (AccountDeviceStates) {
  AccountDeviceStates["Created"] = "Created";
  AccountDeviceStates["Deployed"] = "Deployed";
})(AccountDeviceStates = exports.AccountDeviceStates || (exports.AccountDeviceStates = {}));

var AccountDeviceTypes;

(function (AccountDeviceTypes) {
  AccountDeviceTypes["Owner"] = "Owner";
  AccountDeviceTypes["Delegate"] = "Delegate";
  AccountDeviceTypes["Extension"] = "Extension";
})(AccountDeviceTypes = exports.AccountDeviceTypes || (exports.AccountDeviceTypes = {}));

var AccountGameStates;

(function (AccountGameStates) {
  AccountGameStates["Open"] = "Open";
  AccountGameStates["Opened"] = "Opened";
  AccountGameStates["Started"] = "Started";
  AccountGameStates["Finished"] = "Finished";
})(AccountGameStates = exports.AccountGameStates || (exports.AccountGameStates = {}));

var AccountGamePlayers;

(function (AccountGamePlayers) {
  AccountGamePlayers["Creator"] = "Creator";
  AccountGamePlayers["Opponent"] = "Opponent";
})(AccountGamePlayers = exports.AccountGamePlayers || (exports.AccountGamePlayers = {}));

var AccountTransactionTypes;

(function (AccountTransactionTypes) {
  AccountTransactionTypes["CreateAccount"] = "CreateAccount";
  AccountTransactionTypes["AddDevice"] = "AddDevice";
  AccountTransactionTypes["RemoveDevice"] = "RemoveDevice";
  AccountTransactionTypes["ExecuteTransaction"] = "ExecuteTransaction";
})(AccountTransactionTypes = exports.AccountTransactionTypes || (exports.AccountTransactionTypes = {}));

var AccountTransactionStates;

(function (AccountTransactionStates) {
  AccountTransactionStates["Created"] = "Created";
  AccountTransactionStates["Completed"] = "Completed";
})(AccountTransactionStates = exports.AccountTransactionStates || (exports.AccountTransactionStates = {}));

var AccountPaymentStates;

(function (AccountPaymentStates) {
  AccountPaymentStates["Reserved"] = "Reserved";
  AccountPaymentStates["Locked"] = "Locked";
  AccountPaymentStates["Created"] = "Created";
  AccountPaymentStates["Signed"] = "Signed";
  AccountPaymentStates["Completed"] = "Completed";
  AccountPaymentStates["Processed"] = "Processed";
})(AccountPaymentStates = exports.AccountPaymentStates || (exports.AccountPaymentStates = {}));

var AppStates;

(function (AppStates) {
  AppStates["Accepted"] = "Accepted";
  AppStates["Rejected"] = "Rejected";
})(AppStates = exports.AppStates || (exports.AppStates = {}));

var TokenTypes;

(function (TokenTypes) {
  TokenTypes["ERC20"] = "ERC20";
})(TokenTypes = exports.TokenTypes || (exports.TokenTypes = {}));

var GasPriceStrategies;

(function (GasPriceStrategies) {
  GasPriceStrategies["Avg"] = "Avg";
  GasPriceStrategies["Fast"] = "Fast";
})(GasPriceStrategies = exports.GasPriceStrategies || (exports.GasPriceStrategies = {}));